export class MatRequireMonthPlan {
    constructor({
          id = null,
          code= '', 
          locId= '', 
          locName= ``, 
          month= ``,
          matId= '', 
          matName= '', 
          quantity= '',
          unit = '',        
          status= '',

        
          monthStr= ``,
      } = {}) {
      this.id = id;
      this.code = code;
      this.locId = locId;
      this.locName = locName;
      this.month = month;
      this.matId = matId;
      this.matName = matName;        
      this.quantity = quantity;  
      this.unit = unit;    
      this.status = status;
     
      this.monthStr = monthStr;
    }
  }
  export function gridFields() {
    return Object.freeze([ 
        {
            key: 'code',
            label: 'lbl.matRequireMonthPlan.code',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'locName',
            label: 'lbl.matRequireMonthPlan.locName',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
          key: 'monthStr',
          label: 'lbl.matRequireMonthPlan.month',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'matName',
          label: 'lbl.matRequireMonthPlan.matName',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'quantity',
          label: 'lbl.matRequireMonthPlan.quantity',
          sortable: true,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'unit',
          label: 'lbl.matRequireMonthPlan.unit',
          form: {
            type: 'input'
          }
        },       
        {
          key: 'status',
          label: 'lbl.matRequireMonthPlan.status',
          sortable: true,
          form: {
            type: 'select',
            options: [    
                { value: null, text:  ''  },            
                { value: 'Y', text:  '激活' },
                { value: 'N', text:  '未激活' },                
              ]            
          }
        }
    ]);
  }
  export const fields = Object.freeze(Object.keys(new MatRequireMonthPlan()).map(i => 'entity.' + i));

  export const filterFields = [
    'filter.matNameFilter',
    'filter.locNameFilter',
    'filter.startDateFilter',
    'filter.endDateFilter',
    'filter.statusFilter'
  ];
  export const filter = {
    'matNameFilter': "",
    'locNameFilter': "",
    'startDateFilter': "",
    'endDateFilter': "",
    'statusFilter': ""
  };